import { Platform } from 'react-native';

export const injectWebCss = (f) => {
  // Only on web
  if (Platform.OS === 'web') {
    // Inject style
    const style = document.createElement('style');
    style.textContent = `input { outline: none !important; }`;
    return document.head.append(style);
  } else {
    return;
  }
};
